import { render, staticRenderFns } from "./CustomerProductOtherCode.vue?vue&type=template&id=40cd9ca4&"
import script from "./CustomerProductOtherCode.vue?vue&type=script&lang=js&"
export * from "./CustomerProductOtherCode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports